<template>
    <form action="#">
        <field-input placeholder="Email" name="email" v-model="form.email"></field-input>
        <field-input type="password" placeholder="Password" name="password" v-model="form.password"></field-input>
        <field-input type="password" placeholder="Password Confirmation" name="password" v-model="form.password_confirmation"></field-input>
        <button class="btn btn-nlcaa" @click="save()">
            <i v-if="form.isSubmittted" class="fa fa-spin fa-spinner"></i> Save
        </button>
    </form>
</template>
<script>
    export default {

        props: {
            user: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                form: new Form(Object.assign(this.user, {password: '', password_confirmation: ''}), false),
            }
        },

        methods:{

            save(){
                this.form.patch(`/account`).then(response => {
                    Alert.withAction('Account Information Updated!').then(() => {
                        this.refreshPage();
                    })
                }).catch(errors => {
                    Alert.error(errors.first())
                })
            }
        }
    }
</script>